import React, { useState } from 'react';
import PersonalizedMessage from "./PersonalizedMessage";
import HeartfeltPoem from "./HeartfeltPoem";
import MemoryLane from "./MemoryLane";
import "./App.css"; // Add CSS for global styles
import { Link } from 'react-router-dom';

const MessageGenerator = () => {
  const [activeTab, setActiveTab] = useState("personalized");

  const tabThemes = {
    personalized: {
      background: "#e6f7ff",
      text: "#0050b3",
      hover: { background: "#bae7ff", text: "#003a8c" },
    },
    poem: {
      background: "#fff0f6",
      text: "#ad0045",
      hover: { background: "#ffadd2", text: "#75002c" },
    },
    memory: {
      background: "#f6ffed",
      text: "#389e0d",
      hover: { background: "#b7eb8f", text: "#237804" },
    },
  };

  const currentTheme = tabThemes[activeTab];

  return (
    <div 
      className="app-container"
      style={{
        backgroundColor: currentTheme.background,
        transition: "background-color 0.3s ease-in-out",
        minHeight: "100vh",
        padding: "4px",
      }}
    >
      {/* Header */}
      <div
        style={{
          textAlign: "center",
          color: currentTheme.text,
          fontSize: "24px",
          fontWeight: "bold",
          marginBottom: "4px",
        }}
      >
        <h1> Message Melody </h1>
      </div>
      <div
        style={{
          textAlign: "center",
          color: "#333",
          fontSize: "18px",
          fontWeight: "normal",
          marginBottom: "12px",
        }}
      >
        Looking for something fun? {' '} <Link to="/roast-me" style={{ color: currentTheme.text, textDecoration: 'underline' }}>
          Get Roasted
        </Link>.
      </div>
      <div
        style={{
          textAlign: "center",
          color: "#333",
          fontSize: "18px",
          fontWeight: "normal",
          marginBottom: "12px",
        }}
      >
        Try our new  {' '} <Link to="/wedding-vows-generator" style={{ color: currentTheme.text, textDecoration: 'underline' }}>
          Wedding Vows Generator
        </Link>.
      </div>
      <div className="tabs-container">
        {Object.keys(tabThemes).map((tab) => {
          const theme = tabThemes[tab];
          const isActive = activeTab === tab;

          return (
            <button
              key={tab}
              className="tab-button"
              style={{
                backgroundColor: isActive ? theme.background : "transparent",
                color: isActive ? theme.text : "#333",
                border: isActive ? `2px solid ${theme.text}` : "2px solid transparent",
              }}
              onClick={() => setActiveTab(tab)}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = theme.hover.background;
                e.target.style.color = theme.hover.text;
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = isActive
                  ? theme.background
                  : "transparent";
                e.target.style.color = isActive ? theme.text : "#333";
              }}
            >
              {tab === "personalized"
                ? "Personalized Message"
                : tab === "poem"
                ? "Heartfelt Poem"
                : "Memory Lane"}
            </button>
          );
        })}
      </div>

      <div className="feature-container">
        {activeTab === "personalized" && <PersonalizedMessage />}
        {activeTab === "poem" && <HeartfeltPoem />}
        {activeTab === "memory" && <MemoryLane />}
      </div>
    </div>
  );
};

export default MessageGenerator;
